/**
 * L'AFFICHAGE DES ALIQUOTS — module PUR (aucun import d'exécution).
 * ───────────────────────────────────────────────────────────────────────────
 *
 * Deux règles d'écriture que l'écran et le moteur doivent dire à l'identique,
 * et que `backend/tests/aliquots-affichage-parite.test.js` confronte (le front
 * ne compile pas le backend : la règle existe en deux exemplaires, et c'est ce
 * contrôle qui les tient ensemble).
 *
 *  1. LE NIVEAU COURT (RQ, 03/10/2026) — « N1 » pour un niveau numéroté, la
 *     lettre telle quelle pour « N » ou « P ». Les niveaux sont VERBATIM, les
 *     deux conventions coexistent : préfixer « N » devant une lettre affichait
 *     « Nortrol · NN ». Miroir de `niveauCourt` (`backend/src/cqi-aliquots.ts`).
 *
 *  2. L'HEURE DU LABORATOIRE — un instant (stocké en UTC) se lit à l'heure de
 *     TUNIS, pas à celle du navigateur. Le 03/10/2026, le moteur écrivait
 *     « décongelé à 21:53 » (heure de Tunis, juste) pendant que l'écran
 *     écrivait la limite « 06:53 » à l'heure du poste (Paris, UTC+2, une heure
 *     de plus) : la même fenêtre disait deux heures différentes pour le même
 *     tube. Miroir de `instantLisible` (même module du moteur).
 *     ⚠️ `fmtDateTime` (`lib/meta.ts`) reste à l'heure du navigateur — et
 *     compose une date UTC avec une heure locale : il n'est plus employé par
 *     le circuit des aliquots.
 */

/** Le fuseau du laboratoire — le même défaut que `TZ_LABO` du moteur. */
export const TZ_LABO = 'Africa/Tunis';

export function niveauCourt(niveau: unknown): string {
  const n = String(niveau ?? '').trim();
  return /^\d+$/.test(n) ? `N${n}` : n;
}

/** « 03/10/2026 à 21:53 », à l'heure du laboratoire. `—` si illisible. */
export function instantLabo(iso: string | null | undefined, tz = TZ_LABO): string {
  const ms = Date.parse(String(iso || ''));
  if (!Number.isFinite(ms)) return '—';
  const d = new Date(ms);
  const jour = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
  const h = new Intl.DateTimeFormat('fr-FR', { timeZone: tz, hour: '2-digit', minute: '2-digit' }).format(d);
  return `${jour.slice(8, 10)}/${jour.slice(5, 7)}/${jour.slice(0, 4)} à ${h}`;
}
